// extracted by mini-css-extract-plugin
module.exports = {"Page":"pages-module__Page___2I-uy","InvestmentLocation":"pages-module__InvestmentLocation___nKves"};